var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings"},[(!_vm.loadingCurrentUser)?_c('div',[_c('settings-user',{attrs:{"user":_vm.currentUser || '',"loading":_vm.loadingUsers},on:{"save":_vm.updateCurrentUser}}),_vm._v(" "),_c('settings-alarms',{attrs:{"loading":_vm.loadingUsers,"alarms":_vm.currentUser || ''},on:{"save":_vm.updateAlarams}})],1):_c('loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }